export const isBrowser = typeof window !== 'undefined'
export const isServer = typeof window == 'undefined'

type ILocalStorageData = 'userInfo' | 'accessToken' | 'userId' | 'cid'

// Auth/session data lives in localStorage so the login session survives a browser/tab
// restart. Inactivity is enforced separately: AuthProvider persists a `lastActivity`
// timestamp and logs out after 30 min of no user activity (see @context/Auth.tsx).
export const LocalStorageService = {
  set: (key: ILocalStorageData, value: any): void =>
    localStorage.setItem(key, JSON.stringify(value)),
  get: (key: ILocalStorageData): any | null => JSON.parse(localStorage.getItem(key) || 'null'),
  delete: (key: ILocalStorageData): void => localStorage.removeItem(key),
  clear: (): void => localStorage.clear(),
}
